import { render, staticRenderFns } from "./KheopsPyramid.vue?vue&type=template&id=4c03c17d&"
import script from "./KheopsPyramid.vue?vue&type=script&lang=js&"
export * from "./KheopsPyramid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports